import { AddToPreferences } from '@/features/productSearch/ProductCardActions/index.js'
import styles from './Image.module.css'
import { CloseButton } from 'react-bootstrap'

export const Image = ({ imageLink, productId, item, onClose }) => {
    return (
        <div className={styles.container}>
            <img
                src={imageLink}
                onError={(event) =>
                    (event.currentTarget.src = '/bg/stub-pictures-product.png')
                }
                alt=""
            />
            <div className={styles.actions}>
                <AddToPreferences
                    className={styles.btnPreferences}
                    item={item}
                    productId={productId}
                />
                <CloseButton
                    style={{
                        borderRadius: '0.5rem',
                        backgroundColor: '#e3e3e3',
                    }}
                    className={styles.btnClose}
                    onClick={onClose}
                />
            </div>
        </div>
    )
}
